import { render, staticRenderFns } from "./DeleteDeviceModels.vue?vue&type=template&id=64b16250"
import script from "./DeleteDeviceModels.vue?vue&type=script&lang=ts"
export * from "./DeleteDeviceModels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports